import React from "react";
import Chart from "react-apexcharts";
import { FaDownload } from "react-icons/fa6";
import * as XLSX from "xlsx";
import Loader from "../../../components/reusable-loader/Loader";
import { showSnackbar } from "../../../redux/slices/snackbarSlice";
import { useDispatch } from "react-redux";

const DownloadIcon = FaDownload as unknown as React.FC<
  React.SVGProps<SVGSVGElement>
>;

interface Props {
  data: { name: string; value: number }[];
  loading: boolean;
}

const TotalUsersChart: React.FC<Props> = ({ data, loading }) => {
  const dispatch = useDispatch();
  const maxValue = Math.max(...data.map((d) => d.value));
  const options: ApexCharts.ApexOptions = {
    chart: { type: "bar", toolbar: { show: false } },
    plotOptions: {
      bar: { horizontal: true, barHeight: "60%", borderRadius: 4 },
    },
    states: {
      hover: {
        filter: {
          type: "none",
        },
      },
      active: {
        filter: { type: "none" },
      },
    },
    dataLabels: {
      enabled: true,
      style: { fontSize: "14px", colors: ["#fff"] },
    },
    xaxis: { categories: data.map((d) => d.name), max: Math.max(maxValue, 20) },
    grid: { borderColor: "#e0e0e0" },
    colors: ["#a0522d"],
    noData: {
      text: "No data to display",
      align: "center",
      verticalAlign: "middle",
      style: {
        color: "#666",
        fontSize: "16px",
      },
    },
  };

  const series =
    data.length > 0
      ? [{ name: "Total Users", data: data.map((d) => d.value) }]
      : [];

  // 📌 Download as Excel
  const handleDownload = () => {
    if (!data || data.length === 0) {
      dispatch(
        showSnackbar({
          message: "No data available to download.",
          type: "error",
        }),
      );
      return;
    }

    const monthYear = new Date().toLocaleString("default", {
      month: "short",
      year: "numeric",
    });

    const worksheet = XLSX.utils.json_to_sheet(
      data.map((item, index) => ({
        "S.No": index + 1,
        "Library Name": item.name,
        "Total Users": item.value,
      })),
    );

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Total Users");

    XLSX.writeFile(workbook, `TotalUsersReport_${monthYear}.xlsx`);
  };

  return (
    <div className="chart-box">
      <div className="chart-title">
        Total Users
        <div className="reports-controls">
          <button className="reports-download" onClick={handleDownload}>
            <DownloadIcon /> Download
          </button>
        </div>
      </div>
      {loading ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "400px",
          }}
        >
          <Loader />
        </div>
      ) : (
        <>
          {data.length === 0 ? (
            <div
              style={{
                textAlign: "center",
                padding: "2rem",
                color: "#666",
                fontSize: "16px",
              }}
            >
              No data to display.
            </div>
          ) : (
            <Chart options={options} series={series} type="bar" height={500} />
          )}
        </>
        // <Chart options={options} series={series} type="bar" height={500} />
      )}
    </div>
  );
};

export default TotalUsersChart;
